import { render, staticRenderFns } from "./portimao_text.vue?vue&type=template&id=7f4cb6e6&"
import script from "./portimao_text.vue?vue&type=script&lang=js&"
export * from "./portimao_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports